'use strict'

import React from 'react';

import {EditorState, ContentState, contertFromHtml} from 'draft-js';
import Editor from 'draft-js-plugins-editor';
import createInlineToolbarPlugin, { Separator } from 'draft-js-inline-toolbar-plugin';
import createLinkPlugin from 'draft-js-anchor-plugin';
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  UnorderedListButton,
  OrderedListButton
} from 'draft-js-buttons';

import {stateToHTML} from 'draft-js-export-html';
import {stateFromHTML} from 'draft-js-import-html';

//Copied from FormattedContent
function translateToHTML(content) {
  return content!==undefined && content!==null
    ? content.startsWith("<p>")
      ? content
      : content
        .replace(/\*/g,"<li/>")
        .replace(/\r\n/g,"<br/>")
        .replace(/\n/g,"<br/>")
    : "";
}

export default class RichTextEditor extends React.Component {
  constructor(props) {
    super(props);
    var htmlContent;
    try {
      htmlContent=stateFromHTML(translateToHTML(props.value));
    }
    catch (error) {
    }
    this.state = {
      editorState: props.value!==undefined
        ? EditorState.createWithContent(htmlContent!==undefined ? htmlContent : ContentState.createFromText(props.value))
        : EditorState.createEmpty()
    };
    this.onChange = (editorState) => {
      this.setState({editorState}, ()=>{
        let formattedContent=this.state.editorState.getCurrentContent().hasText() ? stateToHTML(this.state.editorState.getCurrentContent()) : ""; // this.state.editorState.getCurrentContent().getPlainText();
        if (this.props.onChange!==undefined) {
          if ((this.props.value===undefined && formattedContent!=="" || this.props.value!==undefined) && this.props.value!==formattedContent) {
            this.props.onChange({target: {
              name: this.props.name,
              value: formattedContent
            }})
          }
        }
        if (this._content!==undefined) {
          this._content.value=formattedContent;
        }
      })
    };

    this._linkPlugin = createLinkPlugin();
    this._inlineToolbarPlugin = createInlineToolbarPlugin();
  }

  render() {
    let isEmpty=stateToHTML(this.state.editorState.getCurrentContent())==="<p><br></p>";
    return (
      <div className="richTextEditor" style={Object.assign({},this.props.style,{position:"relative", zIndex:0})}>
        {isEmpty ? (
          <div style={{paddingTop:7, zIndex:-1, position:"absolute", color:"grey", userSelect:"none"}}>
            {this.props.help}
          </div>
        ) : null}
       <Editor
         editorState={this.state.editorState}
         onChange={this.onChange}
         plugins={[this._inlineToolbarPlugin,this._linkPlugin]}
         spellCheck={true}
       />
     {isEmpty ? (
         <div style={{zIndex:0,visibility: "hidden"}}>
           {this.props.help}
         </div>
       ) : null}
       <this._inlineToolbarPlugin.InlineToolbar>
         {(externalProps)=>(
           <div>
             <BoldButton {...externalProps} />
             <ItalicButton {...externalProps} />
             <UnderlineButton {...externalProps} />
             <this._linkPlugin.LinkButton {...externalProps}/>
             <Separator {...externalProps}/>
             <UnorderedListButton{...externalProps}/>
             <OrderedListButton {...externalProps}/>
           </div>
         )}
       </this._inlineToolbarPlugin.InlineToolbar>
       <textarea ref={(ref)=>this._content=ref} type="hidden" style={{display: "none", width: "100%", color:"grey", marginTop:10, height: 150}} readOnly={true} name={this.props.name} defaultValue={this.state.editorState.getCurrentContent().getPlainText()}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/RichTextEditor.jsx